module.exports = "/_next/static/public/images/onboarding-tablet-f7667774dd46e0c5ad8daeb4c99eadc0.jpg";